"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const adFile_1 = require("../../types/adFile");
exports.sizeDisplayOrder = [
    adFile_1.AdFileSize.small,
    adFile_1.AdFileSize.medium,
    adFile_1.AdFileSize.large,
    adFile_1.AdFileSize.xLarge,
    adFile_1.AdFileSize.square,
    adFile_1.AdFileSize.long,
    adFile_1.AdFileSize.banner
];
exports.adFileSizes = {
    [adFile_1.AdFileSize.small]: {
        width: 300,
        height: 70
    },
    [adFile_1.AdFileSize.medium]: {
        width: 912,
        height: 70
    },
    [adFile_1.AdFileSize.large]: {
        width: 1920,
        height: 270
    },
    [adFile_1.AdFileSize.xLarge]: {
        width: 1920,
        height: 410
    },
    [adFile_1.AdFileSize.square]: {
        width: 300,
        height: 300
    },
    [adFile_1.AdFileSize.long]: {
        width: 1920,
        height: 140
    },
    [adFile_1.AdFileSize.banner]: {
        width: 510,
        height: 150
    }
};
exports.adFileSizesArray = [
    adFile_1.AdFileSize.small,
    adFile_1.AdFileSize.medium,
    adFile_1.AdFileSize.large,
    adFile_1.AdFileSize.xLarge,
    adFile_1.AdFileSize.square,
    adFile_1.AdFileSize.long,
    adFile_1.AdFileSize.banner
];
exports.adFileSizeKb = 1000;
exports.adFileFormatsArray = [adFile_1.AdFileFormats.jpg, adFile_1.AdFileFormats.jpeg, adFile_1.AdFileFormats.png];
//# sourceMappingURL=adFile.js.map